export default defineNuxtRouteMiddleware(async (to, from) => {
  const { $i18n } = useNuxtApp();

  // Trim '/' from path
  const fullPath = to.path.toLowerCase().replace(/^\/+|\/+$/g, "");
  let path = fullPath;

  // If no current locale set, redirect to "Home" page with default locale
  if (!$i18n.locale.value) {
    return navigateTo(`/${$i18n.fallbackLocale.value}/`);
  }

  // If empty URL, redirect to "Home" page with current locale
  if (!path) {
    return navigateTo(`/${$i18n.locale.value}/`);
  }

  // If current locale set but different from the one in the URL, redirect to the URL
  const subPath = path.split("/");
  if (subPath && subPath.length > 0) {
    const pathLocale = subPath[0];
    if (pathLocale.length === 2 && pathLocale !== $i18n.locale.value) {
      return;
    }
  }

  // If first part = current locale, trim it. Otherwise, redirect to current page with locale
  const localePath = `${$i18n.locale.value}/`;
  if (fullPath === $i18n.locale.value || fullPath === localePath) {
    path = "";
  } else if (fullPath.startsWith(localePath)) {
    path = path.slice(localePath.length);
  } else {
    let url = `/${$i18n.locale.value}/${fullPath}`;
    if (!url.endsWith("/")) url = url + "/";
    return navigateTo(url);
  }

  // If pages "login" or "open", continue
  if (["login", "open"].includes(path)) {
    return;
  }

  // If user logged in, continue
  const isLoggedIn = await useUser().getUserIsLoggedIn();
  if (isLoggedIn) {
    return;
  }

  // Otherwise, redirect to "login" page
  return navigateTo(`/${$i18n.locale.value}/login/`);
});
